import { render, staticRenderFns } from "./WhereToBuy.vue?vue&type=template&id=6cbec1b6&scoped=true&"
import script from "./WhereToBuy.vue?vue&type=script&lang=js&"
export * from "./WhereToBuy.vue?vue&type=script&lang=js&"
import style0 from "./WhereToBuy.vue?vue&type=style&index=0&id=6cbec1b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbec1b6",
  null
  
)

export default component.exports